<div class="mat-elevation-z8">
  <!-- <div class="search-container">
    <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" />
  </div> -->
  <div class="flex justify-end items-center mb-4">
    <input type="search" class="input input-sm max-w-72" matInput (keyup)="applyFilter($event)" placeholder="Buscar por ID o Nombre">
  </div>
  <table mat-table [dataSource]="dataSource" matSort>

    <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="column.width || 'auto'">
        <ng-container *ngIf="!column.showSelectAll; else selectAllHeaderTemplate">
          {{ column.header }}
        </ng-container>
        <ng-template #selectAllHeaderTemplate>
          <mat-checkbox
            [checked]="areAllSelected()"
            [indeterminate]="isIndeterminate()"
            (change)="onSelectAllChange($event)"
          ></mat-checkbox>
          {{ column.header }}
        </ng-template>
      </th>
      <td mat-cell *matCellDef="let element" [style.width]="column.width || 'auto'">
        <ng-container *ngIf="!column.isCheckbox; else checkboxTemplate">
          <ng-container *ngIf="column.isDate; else timeOrDefaultContent">
            {{ getNestedValue(element, column.field) | dateFormat:'date' }}
          </ng-container>
          <ng-template #timeOrDefaultContent>
            <ng-container *ngIf="column.isTime; else defaultContent">
              {{ getNestedValue(element, column.field) | dateFormat:'datetime' }}
            </ng-container>
          </ng-template>
          <ng-template #defaultContent>{{ getNestedValue(element, column.field) }}</ng-template>
        </ng-container>
        <ng-template #checkboxTemplate>
          <mat-checkbox
            [checked]="getNestedValue(element, column.field)"
            (change)="emitCheckboxChange($event, element)"
          ></mat-checkbox>
        </ng-template>        
      </td>
    </ng-container>
    

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="actions-column">Acciones</th>
      <td mat-cell *matCellDef="let element" class="actions-column">
        <ng-container *ngTemplateOutlet="actionTemplate; context: { $implicit: element }"></ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator 
    [pageSizeOptions]="pageSizeOptions" 
    [pageSize]="initialPageSize"
    showFirstLastButtons>
  </mat-paginator>
</div>
